import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { MissingInputError } from '@shared/errors/missing-input/missing-input.error';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RecipesTranslationFieldComponent } from '@recipes/recipes-translation/recipes-translation-field/recipes-translation-field.component';

export interface FieldsOptions {
  label?: string;
  size?: 'sm' | 'normal';
  placeholder?: string;
  sourceControl: { left: FormControl<string>; right?: FormControl<string> };
  targetControl: { left: FormControl<string>; right?: FormControl<string> };
  fieldName?: {
    left: string;
    right?: string;
  };
}

@Component({
  selector: 'app-recipes-translation-input-fields',
  styleUrls: ['./recipes-translation-input-fields.component.scss'],
  templateUrl: './recipes-translation-input-fields.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatInputModule, MatIconModule, ReactiveFormsModule, NgIf, TranslateModule, RecipesTranslationFieldComponent],
})
export class RecipesTranslationInputFieldsComponent implements OnInit {
  @Input() fieldsOptions: FieldsOptions;
  translatedFieldLabel: string;

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    if (!this.fieldsOptions) {
      throw new MissingInputError('fieldsOptions');
    }

    this.translatedFieldLabel = this.fieldsOptions.label ? this.translateService.instant(this.fieldsOptions.label) : '';
  }
}
